module.exports = __webpack_public_path__ + "img/login-background.5107e61f.png";